import { Injectable } from '@angular/core';
import { NodeConstraints } from '@syncfusion/ej2-angular-diagrams';

@Injectable({
  providedIn: 'root'
})
export class MinicelleserviceService {

  constructor() { }
  
  getDataElectrolux() {
    return [
        {
            "id": "minicella12x16",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
            "width": 12,
            "height": 16,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Electrolux",
                "title": "320x320",
                "nodeWidth": 12,
                "nodeHeight": 16
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">12x16<\/div>"
            }
        },
        {
            "id": "minicella16x16",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
            "width": 16,
            "height": 16,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Electrolux",
                "title": "320x320",
                "nodeWidth": 16,
                "nodeHeight": 16
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">16x16<\/div>"
            }
        },
        {
            "id": "minicella20x16",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
            "width": 20,
            "height": 16,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Electrolux",
                "title": "320x320",
                "nodeWidth": 20,
                "nodeHeight": 16
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">20x16<\/div>"
            }
        },
        {
            "id": "minicella24x16",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
            "width": 24,
            "height": 16,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Electrolux",
                "title": "320x320",
                "nodeWidth": 24,
                "nodeHeight": 16
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">24x16<\/div>"
            }
        },
        {
            "id": "minicella28x16",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
            "width": 28,
            "height": 16,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Electrolux",
                "title": "320x320",
                "nodeWidth": 28,
                "nodeHeight": 16
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">28x16<\/div>"
            }
        },
        {
            "id": "minicella24x20",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
            "width": 24,
            "height": 20,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Electrolux",
                "title": "320x320",
                "nodeWidth": 24,
                "nodeHeight": 20
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">24x20<\/div>"
            }
        },
        {
            "id": "minicella28x24",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
            "width": 28,
            "height": 24,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Electrolux",
                "title": "320x320",
                "nodeWidth": 28,
                "nodeHeight": 24
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">28x24<\/div>"
            }
        },
        {
            "id": "minicella12x12",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
            "width": 12,
            "height": 12,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Electrolux",
                "title": "320x320",
                "nodeWidth": 12,
                "nodeHeight": 12
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">12x12<\/div>"
            }
        },
        {
            "id": "minicella12x20",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
            "width": 12,
            "height": 20,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Electrolux",
                "title": "320x320",
                "nodeWidth": 12,
                "nodeHeight": 20
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">12x20<\/div>"
            }
        },
        {
            "id": "minicella12x24",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
            "width": 12,
            "height": 24,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Electrolux",
                "title": "320x320",
                "nodeWidth": 12,
                "nodeHeight": 24
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">12x24<\/div>"
            }
        },
        {
            "id": "minicella16x20",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
            "width": 16,
            "height": 20,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Electrolux",
                "title": "320x320",
                "nodeWidth": 16,
                "nodeHeight": 20
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">16x20<\/div>"
            }
        },
        {
            "id": "minicella16x24",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
            "width": 16,
            "height": 24,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Electrolux",
                "title": "320x320",
                "nodeWidth": 16,
                "nodeHeight": 24
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">16x24<\/div>"
            }
        },
        {
            "id": "minicella16x28",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
            "width": 16,
            "height": 28,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Electrolux",
                "title": "320x320",
                "nodeWidth": 16,
                "nodeHeight": 28
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">16x28<\/div>"
            }
        },
        {
            "id": "minicella20x20",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
            "width": 20,
            "height": 20,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Electrolux",
                "title": "320x320",
                "nodeWidth": 20,
                "nodeHeight": 20
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">20x20<\/div>"
            }
        },
        {
            "id": "minicella20x24",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
            "width": 20,
            "height": 24,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Electrolux",
                "title": "320x320",
                "nodeWidth": 20,
                "nodeHeight": 24
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">20x24<\/div>"
            }
        },
        {
            "id": "minicella20x28",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
            "width": 20,
            "height": 28,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Electrolux",
                "title": "320x320",
                "nodeWidth": 20,
                "nodeHeight": 28
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">20x28<\/div>"
            }
        },
        {
            "id": "minicella24x24",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
            "width": 24,
            "height": 24,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Electrolux",
                "title": "320x320",
                "nodeWidth": 24,
                "nodeHeight": 24
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">24x24<\/div>"
            }
        },
        {
            "id": "minicella24x28",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
            "width": 24,
            "height": 28,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Electrolux",
                "title": "320x320",
                "nodeWidth": 24,
                "nodeHeight": 28
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">24x28<\/div>"
            }
        }
    ]

  }
  getDataMisa() {
    return  [
        {
            "id": "minicella12x12",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 12,
            "height": 12,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 12,
                "nodeHeight": 12
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">12x12<\/div>"
            }
        },
        {
            "id": "minicella12x14",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 12,
            "height": 14,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 12,
                "nodeHeight": 14
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">12x14<\/div>"
            }
        },
        {
            "id": "minicella12x16",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 12,
            "height": 16,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 12,
                "nodeHeight": 16
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">12x16<\/div>"
            }
        },
        {
            "id": "minicella12x18",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 12,
            "height": 18,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 12,
                "nodeHeight": 18
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">12x18<\/div>"
            }
        },
        {
            "id": "minicella12x20",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 12,
            "height": 20,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 12,
                "nodeHeight": 20
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">12x20<\/div>"
            }
        },
        {
            "id": "minicella12x22",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 12,
            "height": 22,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 12,
                "nodeHeight": 22
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">12x22<\/div>"
            }
        },
        {
            "id": "minicella12x24",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 12,
            "height": 24,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 12,
                "nodeHeight": 24
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">12x24<\/div>"
            }
        },
        {
            "id": "minicella12x28",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 12,
            "height": 28,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 12,
                "nodeHeight": 28
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">12x28<\/div>"
            }
        },
        {
            "id": "minicella14x14",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 14,
            "height": 14,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 14,
                "nodeHeight": 14
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">14x14<\/div>"
            }
        },
        {
            "id": "minicella14x16",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 14,
            "height": 16,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 14,
                "nodeHeight": 16
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">14x16<\/div>"
            }
        },
        {
            "id": "minicella14x18",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 14,
            "height": 18,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 14,
                "nodeHeight": 18
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">14x18<\/div>"
            }
        },
        {
            "id": "minicella14x20",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 14,
            "height": 20,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 14,
                "nodeHeight": 20
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">14x20<\/div>"
            }
        },
        {
            "id": "minicella14x22",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 14,
            "height": 22,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 14,
                "nodeHeight": 22
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">14x22<\/div>"
            }
        },
        {
            "id": "minicella14x24",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 14,
            "height": 24,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 14,
                "nodeHeight": 24
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">14x24<\/div>"
            }
        },
        {
            "id": "minicella14x28",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 14,
            "height": 28,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 14,
                "nodeHeight": 28
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">14x28<\/div>"
            }
        },
        {
            "id": "minicella16x16",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 16,
            "height": 16,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 16,
                "nodeHeight": 16
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">16x16<\/div>"
            }
        },
        {
            "id": "minicella16x18",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 16,
            "height": 18,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 16,
                "nodeHeight": 18
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">16x18<\/div>"
            }
        },
        {
            "id": "minicella16x20",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 16,
            "height": 20,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 16,
                "nodeHeight": 20
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">16x20<\/div>"
            }
        },
        {
            "id": "minicella16x22",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 16,
            "height": 22,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 16,
                "nodeHeight": 22
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">16x22<\/div>"
            }
        },
        {
            "id": "minicella16x24",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 16,
            "height": 24,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 16,
                "nodeHeight": 24
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">16x24<\/div>"
            }
        },
        {
            "id": "minicella16x28",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 16,
            "height": 28,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 16,
                "nodeHeight": 28
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">16x28<\/div>"
            }
        },
        {
            "id": "minicella18x18",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 18,
            "height": 18,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 18,
                "nodeHeight": 18
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">18x18<\/div>"
            }
        },
        {
            "id": "minicella18x20",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 18,
            "height": 20,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 18,
                "nodeHeight": 20
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">18x20<\/div>"
            }
        },
        {
            "id": "minicella18x22",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 18,
            "height": 22,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 18,
                "nodeHeight": 22
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">18x22<\/div>"
            }
        },
        {
            "id": "minicella18x24",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 18,
            "height": 24,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 18,
                "nodeHeight": 24
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">18x24<\/div>"
            }
        },
        {
            "id": "minicella18x28",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 18,
            "height": 28,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 18,
                "nodeHeight": 28
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">18x28<\/div>"
            }
        },
        {
            "id": "minicella20x20",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 20,
            "height": 20,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 20,
                "nodeHeight": 20
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">20x20<\/div>"
            }
        },
        {
            "id": "minicella20x22",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 20,
            "height": 22,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 20,
                "nodeHeight": 22
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">20x22<\/div>"
            }
        },
        {
            "id": "minicella20x24",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 20,
            "height": 24,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 20,
                "nodeHeight": 24
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">20x24<\/div>"
            }
        },
        {
            "id": "minicella20x28",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 20,
            "height": 28,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 20,
                "nodeHeight": 28
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">20x28<\/div>"
            }
        },
        {
            "id": "minicella22x22",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 22,
            "height": 22,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 22,
                "nodeHeight": 22
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">22x22<\/div>"
            }
        },
        {
            "id": "minicella22x24",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 22,
            "height": 24,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 22,
                "nodeHeight": 24
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">22x24<\/div>"
            }
        },
        {
            "id": "minicella22x28",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 22,
            "height": 28,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 22,
                "nodeHeight": 28
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">22x28<\/div>"
            }
        },
        {
            "id": "minicella24x24",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 24,
            "height": 24,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 24,
                "nodeHeight": 24
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">24x24<\/div>"
            }
        },
        {
            "id": "minicella24x28",
            "constraints": NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints. Resize,
            "width": 24,
            "height": 28,
            "zIndex": 0,
            "addInfo": {
                "type": "cella",
                "isMiniCella": true,
                "customClient": "Standard\/Misa",
                "title": "320x320",
                "nodeWidth": 24,
                "nodeHeight": 28
            },
            "shape": {
                "type": "HTML",
                "content": "<div style=\"width:100%;height:100%;text-align:center;\">24x28<\/div>"
            }
        }
    ]

  }
}
